import { lazy } from 'react'
import { type PagesType } from '@/shared/models/pages'

export const Pages: PagesType = {
    Home: {
        component: lazy(() => import('./home/HomePage')),
        urls: ['/'],
    },
    Generic: {
        component: lazy(() => import('./generic/GenericPage')),
        urls: ['/'],
    },
    Cinemas: {
        component: lazy(() => import('@/web/pages/cinemas/allCinemas/AllCinemasPage')),
        urls: ['/'],
    },
    Cinema: {
        component: lazy(() => import('@/web/pages/cinemas/cinema/CinemaPage')),
        urls: ['/'],
    },
    Films: {
        component: lazy(() => import('./films/FilmsPage')),
        urls: ['/'],
    },
    FilmDetails: {
        parent: 'Films',
        component: lazy(() => import('./filmDetails/FilmDetailsPage')),
        urls: ['/'],
        params: ['filmName', 'filmId'],
        customAlias: 'filmDetails',
    },
    Events: {
        component: lazy(() => import('./events/EventsPage')),
        urls: ['/'],
    },
    EventDetails: {
        parent: 'Events',
        component: lazy(() => import('./eventDetails/EventDetailsPage')),
        urls: ['/'],
        params: ['eventName', 'eventId'],
        customAlias: 'eventDetails',
    },
    Account: {
        component: lazy(() => import('./account/AccountLayoutPage')),
        urls: ['/'],
        subPages: [
            {
                alias: 'AccountOverview',
                component: lazy(() => import('./account/subpages/overview/AccountOverviewPage')),
                urls: [],
            },
            {
                alias: 'AccountProfile',
                component: lazy(() => import('./account/subpages/profile/AccountProfilePage')),
                urls: [],
            },
            {
                alias: 'AccountDetails',
                component: lazy(() => import('./account/subpages/details/AccountDetailsPage')),
                urls: [],
            },
            {
                alias: 'AccountBookings',
                component: lazy(() => import('./account/subpages/bookings/AccountBookingsPage')),
                urls: [],
            },
            {
                alias: 'AccountMembership',
                component: lazy(() => import('./account/subpages/membership/AccountMembershipPage')),
                urls: [],
            },
            {
                alias: 'AccountPaymentCards',
                component: lazy(() => import('./account/subpages/paymentCards/AccountPaymentCardsPage')),
                urls: [],
            },
            {
                alias: 'AccountWatchlist',
                component: lazy(() => import('./account/subpages/watchlist/AccountWatchlistPage')),
                urls: [],
            },
            {
                alias: 'AccountCompleteProfile',
                component: lazy(() => import('./account/subpages/completeProfile/AccountCompleteProfilePage')),
                urls: [],
            },
        ],
    },
    ErrorNotFound: {
        component: lazy(() => import('./404/NotFoundPage')),
        urls: ['/'],
    },
}
